export type PartialRequired<T, K extends keyof T> = Partial<T> & Pick<T, K>
